/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';


const emptyStats = {
	header:[
		{ id: 'min', name: 'Min' },
		{ id: 'max', name: 'Max' },
		{ id: 'avg', name: 'Average' },
		{ id: 'total', name: 'Total' },
		{ id: 'totalPercent', name: '%Total' }
	]
};

const emptySelStats = {
	header:[
		{ id: 'values', name: 'Values' }
	]
};

export default class CompareUtils  {
	constructor(props) {
		this.services = props.services;
		this.model = props.model;
		this.dashboardApi = props.dashboardApi;
		this.model.compareModel.setDashboardApi(this.dashboardApi);
	}


	initialize(widgetId, cardModel) {
		const abortPromiseMessage = 'do nothing for non live widgets';
		return this.dashboardApi.getCanvasWhenReady()
			.then((canvas)=>{
				// board spec will not be ready until canvas is ready
				let isVisualization = false;
				const widgets = this.dashboardApi.getFeature('internal').getBoardModel().widgetInstances;
				isVisualization = widgets[widgetId].type === 'live';
				if( isVisualization && this.model.isCompareEnabled ) {
					const measureLabel = StringResources.get('cardStats_measureLabel');
					const widgetAlias = this._getWidgetAlias( widgetId, cardModel && cardModel.items);
					this.model.addStatsModels(widgetId, emptyStats, emptySelStats, measureLabel, widgetAlias);
					this.model.compareModel.initializeWidgetSelectionsSynced(this.model.boardModel && this.model.boardModel.eventGroups);
					return canvas;
				} else {
					throw new Error(abortPromiseMessage);
				}
			})
			.then(canvas => {
				return canvas.getWidgetWhenReady(widgetId)
					.then(() => canvas);
			})
			.then(canvas => {
				const widgetContentApi = canvas.getContent(widgetId);
				const compareModel = this.model.compareModel;
				compareModel.initializeWidgetApis(widgetContentApi);
				compareModel.initializeSynch(widgetContentApi);
				return this.model.setupStatsModels(widgetId, widgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-summarizer'));
			}).catch((error) => {
				if (error.message === abortPromiseMessage) {
					// just swallow error because chain was intentionally aborted
					return true;
				} else {
					// else let the error bubble up because it's coming from somewhere else
					throw error;
				}
			});
	}

	_getWidgetAlias(widgetId, items) {
		items = items || [];
		const widgetAliasStart = 65;
		let index = items.findIndex( (e) => e.id === widgetId);
		index = (index > -1) ? index : 0;
		return String.fromCharCode(widgetAliasStart+index);
	}


}



// WEBPACK FOOTER //
// ./src/js/layout/explorecard/compare/CompareUtils.js